// Example locale file for Spanish, give this to your locale team to translate

export const AG_GRID_LOCALE_ES = {
    // Set Filter
    selectAll: '(Seleccionar todo)',
    selectAllSearchResults: '(Seleccionar todos los resultados de la búsqueda)',
    searchOoo: 'Busque en...',
    blanks: '(En blanco)',
    noMatches: 'No hay coincidencia',

    // Number Filter & Text Filter
    filterOoo: 'Filtro...',
    equals: 'Igual que',
    notEqual: 'Diferente de',
    blank: 'Vacío',
    notBlank: 'No está vacío',
    empty: 'Elige uno',

    // Number Filter
    lessThan: 'Menos de',
    greaterThan: 'Mayor que',
    lessThanOrEqual: 'Menos de o igual a',
    greaterThanOrEqual: 'Mayor o igual que',
    inRange: 'Entre',
    inRangeStart: 'Desde',
    inRangeEnd: 'a',

    // Text Filter
    contains: 'Contiene',
    notContains: 'No contiene',
    startsWith: 'Comienza con',
    endsWith: 'Termina con',

    // Date Filter
    dateFormatOoo: 'aaaa-mm-gg',

    // Filter Conditions
    andCondition: 'y',
    orCondition: 'o',

    // Filter Buttons
    applyFilter: 'Aplicar',
    resetFilter: 'Restaurar',
    clearFilter: 'Eliminar',
    cancelFilter: 'Borrar',

    // Filter Titles
    textFilter: 'Filtros de texto',
    numberFilter: 'Filtros numéricos',
    dateFilter: 'Filtros por fecha',
    setFilter: 'Fijar el filtro',

    // Side Bar
    columns: 'Columnas',
    filters: 'Filtros',

    // columns tool panel
    pivotMode: 'Tabla dinámica',
    groups: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Arrastre y suelte aquí para establecer grupos de filas',
    values: 'Valores',
    valueColumnsEmptyMessage: 'Arrastre aquí para agregar',
    pivots: 'Etiqueta de la columna',
    pivotColumnsEmptyMessage: 'Arrastre aquí para establecer las etiquetas de las columnas',

    // Header of the Default Group Column
    group: 'Grupo',

    // Row Drag
    rowDragRows:'Filas',

    // Other
    loadingOoo: 'Cargando...',
    noRowsToShow: 'No hay filas que mostrar',
    enabled: 'Activado',

    // Menu
    pinColumn: 'Columna de bloqueo',
    pinLeft: 'Bloqueo a la izquierda',
    pinRight: 'Bloqueo a la derecha',
    noPin: 'Desbloquear',
    valueAggregation: 'Valores agregados',
    autosizeThiscolumn: 'Escala automática de esta columna',
    autosizeAllColumns: 'Tamaño automático de todas las columnas',
    groupBy: 'Grupo por ',
    ungroupBy: 'Desagrupar  ',
    addToValues: 'Add ${variable} to values',
    removeFromValues: 'Remove ${variable} from values',
    addToLabels: 'Add ${variable} to labels',
    removeFromLabels: 'Remove ${variable} from labels',
    resetColumns: 'Reset Columns',
    expandAll: 'Ampliar todo',
    collapseAll: 'Cerrar todo',
    copy: 'Copiar',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copia con cabecera',
    copyWithHeaderGroups: 'Copia con grupos de cabecera',
    paste: 'Pegar',
    ctrlV: 'Ctrl+V',
    export: 'Exportar',
    csvExport: 'Exportar csv',
    excelExport: 'Exportación a Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Suma',
    min: 'Min',
    max: 'Max',
    none: 'Ninguno',
    count: 'Contar números',
    avg: 'Media',
    filteredRows: 'Filtrado',
    selectedRows: 'Seleccionado',
    totalRows: 'Total de filas',
    totalAndFilteredRows: 'Filas',
    more: 'Otros',
    to: 'to',
    of: 'of',
    page: 'Página',
    nextPage: 'Página siguiente',
    lastPage: 'Última página',
    firstPage: 'Primera página',
    previousPage: 'Página anterior',

    // Pivoting
    pivotColumnGroupTotals: 'Total',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Tabla dinámica',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Gráfico de barras',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Gráfico circular',
    pie: 'Pastel',
    doughnut: 'Anillo',

    line: 'Gráfico de líneas',

    xyChart: 'Gráfico de dispersión (XY)',
    scatter: 'Dispersión',
    bubble: 'Burbuja',

    areaChart: 'Gráfico de áreas',
    area: 'Área',
    stackedArea: 'Área en la pila',
    normalizedArea: 'Área 100% apilada',

    histogramChart: 'Histograma',

    combinationChart: 'Combination',
    columnLineCombo: 'Column & Line',
    AreaColumnCombo: 'Area & Column',

    // Charts
    pivotChartTitle: 'Tabla dinámica',
    rangeChartTitle: 'Range Chart',
    settings: 'Ajustes',
    data: 'Dati',
    format: 'Formato',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Anchura',
    height: 'Altura',
    length: 'Longitud',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Gráfico',
    title: 'Título',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Negrita',
    italic: 'Cursiva',
    boldItalic: 'Negrita y cursiva',
    predefined: 'Por defecto',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    combinationGroup: 'Combination',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    columnLineComboTooltip: 'Column & Line',
    areaColumnComboTooltip: 'Area & Column',
    customComboTooltip: 'Custom Combination',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart',
    seriesChartType: 'Series Chart Type',
    seriesType: 'Series Type',
    secondaryAxis: 'Secondary Axis',

    // ARIA
    ariaHidden: 'hidden',
    ariaVisible: 'visible',
    ariaChecked: 'checked',
    ariaUnchecked: 'unchecked',
    ariaIndeterminate:'indeterminate',
    ariaDefaultListName: 'List',
    ariaColumnSelectAll: 'Toggle Select All Columns',
    ariaInputEditor: 'Input Editor',
    ariaDateFilterInput: 'Date Filter Input',
    ariaFilterList: 'Filter List',
    ariaFilterInput: 'Filter Input',
    ariaFilterColumnsInput: 'Filter Columns Input',
    ariaFilterValue: 'Filter Value',
    ariaFilterFromValue: 'Filter from value',
    ariaFilterToValue: 'Filter to value',
    ariaFilteringOperator: 'Filtering Operator',
    ariaColumn: 'Column',
    ariaColumnList: 'Column List',
    ariaColumnGroup: 'Column Group',
    ariaRowSelect: 'Press SPACE to select this row',
    ariaRowDeselect: 'Press SPACE to deselect this row',
    ariaRowToggleSelection: 'Press Space to toggle row selection',
    ariaRowSelectAll: 'Press Space to toggle all rows selection',
    ariaToggleVisibility: 'Press SPACE to toggle visibility',
    ariaSearch: 'Search',
    ariaSearchFilterValues: 'Search filter values',

    ariaRowGroupDropZonePanelLabel: 'Row Groups',
    ariaValuesDropZonePanelLabel: 'Values',
    ariaPivotDropZonePanelLabel: 'Column Labels',
    ariaDropZoneColumnComponentDescription: 'Press DELETE to remove',
    ariaDropZoneColumnValueItemDescription: 'Press ENTER to change the aggregation type',

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: 'Column Menu',
    ariaLabelCellEditor: 'Cell Editor',
    ariaLabelDialog: 'Dialog',
    ariaLabelSelectField: 'Select Field',
    ariaLabelTooltip: 'Tooltip',
    ariaLabelContextMenu: 'Context Menu',
    ariaLabelSubMenu: 'SubMenu',
    ariaLabelAggregationFunction: 'Aggregation Function',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ',',
    decimalSeparator: '.',

}